import { createAsyncThunk } from '@reduxjs/toolkit'

import type { RootState } from 'redux/store/RootReducer'
import type { AppDispatch } from 'redux/store'
import locationsAPI from 'api/ApiActions/Participant/Locations'
import filterLocationsAPI from 'api/ApiActions/Participant/FilterLocations'

export const fetchLocations: any = createAsyncThunk<
  any,
  any,
  {
    dispatch: AppDispatch
    state: RootState
  }
>(
  'location_lookups/participant_addresses',
  async (_obj, { rejectWithValue }) => {
    try {
      const response = await locationsAPI.getLocations(_obj)
      return response.data.data
    } catch (error) {
      return rejectWithValue(error)
    }
  },
)

export const fetchFilterLocations: any = createAsyncThunk<
  any,
  any,
  {
    dispatch: AppDispatch
    state: RootState
  }
>('filters/locations', async (_obj, { rejectWithValue }) => {
  try {
    const response = await filterLocationsAPI.getFilterLocations(_obj)
    return response.data?.data
  } catch (error) {
    return rejectWithValue(error)
  }
})
